import React from "react";
import "./header.css";
import { useContext } from "react";
import AuthContext from "../store/auth-context";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

function Header(props) {
  const c = useContext(AuthContext);
  function logoutHandler() {
    c.logout();
  }
  const goToProfile = () => {
    c.setProfile(true);
  };
  return (
    <Navbar collapseOnSelect expand="md" className="navBar" variant="dark">
      <Container className="nav">
        <Navbar.Brand href="/" className="name">
          Budget Master
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav" className="navBar">
          <Nav className="me-auto"></Nav>
          <Nav>
            <Nav.Link onClick={props.downloadPdf}>Download Summary</Nav.Link>
            <Nav.Link onClick={goToProfile}>Profile</Nav.Link>
            <Nav.Link onClick={logoutHandler}>Logout</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
